import React, { createContext, useContext } from 'react';
import { useTheme, useMediaQuery } from '@mui/material';

export interface DeviceContextType {
  isMobile: boolean;
}

const DeviceContext = createContext<DeviceContextType>({} as DeviceContextType);

function useDeviceContext() {
  return useContext(DeviceContext);
}

function DeviceContextProvider({ children }: { children?: React.ReactNode }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const value: DeviceContextType = {
    isMobile,
  };

  return (
    <DeviceContext.Provider value={value}>{children}</DeviceContext.Provider>
  );
}

export { DeviceContextProvider, useDeviceContext };
